import { useEffect, useState } from 'react'
import axiosInstance from '../services/config/AxiosIntance'

function useFeatureFlag(name) {
  const [activeFlag, setActiveFlag] = useState(false)

  const fetchFlag = () => {
    axiosInstance
      .get('/feature-flag', {
        params: { name: name },
      })
      .then((res) => {
        if (res?.data?.result?.is_active === 1) {
          setActiveFlag(true)
        } else {
          setActiveFlag(false)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    fetchFlag()
  }, [])

  return { activeFlag }
}

export default useFeatureFlag
